import { useMemo } from 'react';

import type { TAdditionalDataFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';
import { getProtectedDescriptionWithUserData } from './getProtectedDescriptionWithUserData';
import { getProtectedTitleWithUserData } from './getProtectedTitleWithUserData';

type THeaderParams = {
  title: string;
  icon: string;
  description: string;
};

type DefaultParams = Partial<Pick<THeaderParams, 'title' | 'description'>>;

export const useAccordionHeaderParams = (
  data: Nullable<TAdditionalDataFormFields>,
  defaultData: DefaultParams,
  isOpen: boolean,
  isHideData?: boolean,
) => {
  const {
    title = defaultData.title || AccordionHeaderParamsTexts.HeaderDefaultTitle,
    description = defaultData.description || AccordionHeaderParamsTexts.HeaderDefaultDescription,
  } = useMemo((): Partial<THeaderParams> => {
    if (!data || isOpen) {
      return {};
    }

    const titleWithUserData = getProtectedTitleWithUserData(data.additionalPhone, isHideData);

    const descriptionWithUserData = getProtectedDescriptionWithUserData(data.additionalPhoneOwner?.label, isHideData);

    return {
      title: titleWithUserData || AccordionHeaderParamsTexts.HeaderDefaultTitle,
      description: descriptionWithUserData || AccordionHeaderParamsTexts.HeaderDefaultDescription,
    };
  }, [data, isOpen, isHideData]);

  return [title, description] as const;
};
